import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function find(predicate) {
    return function (source) { return new Observable(function (subscriber) { return createFind(predicate, 'value', source, subscriber); }); };
}
export function createFind(predicate, emit, source, subscriber) {
    var findIndex = emit === 'index';
    var index = 0;
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var i = index++;
        if (predicate(value, i, source)) {
            subscriber.next(findIndex ? i : value);
            subscriber.complete();
        }
    }, function () {
        subscriber.next(findIndex ? -1 : undefined);
        subscriber.complete();
    }));
}
//# sourceMappingURL=find.js.map